import request from '@/utils/request'

export function adList(data) {
  return request({
    url: 'index.php?s=AdTk/list',
    method: 'post',
    data,
  })
}

export function adSec(data) {
  return request({
    url: 'index.php?s=AdTk/sec',
    method: 'post',
    data,
  })
}

export function adListNew(data) {
  return request({
    url: 'index.php?s=AdTk/list_new',
    method: 'post',
    data,
  })
}

export function adComicView(data) {
  return request({
    url: 'index.php?s=AdTk/view',
    method: 'post',
    data
  })
}

export function reportAd(data){
  return request({
    url: 'index.php?s=AdTk/report',
    method: 'post',
    data,
  })
}

export function getButStatus() {
  return request({
    url: 'index.php?s=AdTk/getButStatus',
    method: 'get'
  })
}

export function adUserReport(data){
  return request({
    url: 'index.php?s=AdTk/userReport',
    method: 'post',
    data,
  })
}
